






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {CargaResponsavel} from '@/model/resource/CargaResponsavel'
import {InputCargaResponsavelSchema} from '@/schema/resource/CargaResponsavel/InputCargaResponsavelSchema'

@Component
export default class PersistCargaResponsavelView extends Vue {
  @Prop() id1?: string
  @Prop() id2?: string

  @Provide('validator') validator = this.$validator

  schema = new InputCargaResponsavelSchema()
  cargaResponsavel = new CargaResponsavel()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionCarga.listCarga()
    this.schema.collectionEndereco.listEndereco()
    this.schema.collectionResponsavel.listResponsavel()
    this.schema.collectionResponsavelFilial.listResponsavelFilial()
  }

  async populate() {
    const id1 = Number(this.id1) || null
    const id2 = Boolean(this.id2) || null

    if (id1 && id2) {
      await this.cargaResponsavel.getCargaResponsavel(id1, id2)
    }

    $.await.done('getCargaResponsavel')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.cargaResponsavel.persistCargaResponsavel()
    await Helper.successAndPush(
      'system.success.persist',
      '/carga-responsavel/list'
    )
  }
}
